import React, { useState } from "react";
import { t } from "i18next";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { stepTypes } from "components/Custom/AnswerTypeDialog/constants";

const SelectMenuStep = ({ onSelectTedMenuStep, stepTypeSelected, isEdit = false }) => {
	const handleChange = event => {
		const selectedStep = event.target.value;
		onSelectTedMenuStep(selectedStep);
	};

	return (
		<FormControl sx={{ width: "25%" }}>
			<InputLabel id="custom-select-label">{t("LABELS.types")}</InputLabel>
			<Select
				labelId="custom-select-label"
				id="custom-select"
				value={stepTypeSelected}
				label={t("LABELS.types")}
				onChange={handleChange}
				readOnly={isEdit}
				renderValue={selected => {
					const selectedStepType = stepTypes.find(stepType => stepType.type === selected);
					if (!selectedStepType) return null;
					return (
						<div style={{ display: "flex", alignItems: "center" }}>
							{selectedStepType.icon}
							<span style={{ marginLeft: 8 }}>{t(selectedStepType.label)}</span>
						</div>
					);
				}}
			>
				{stepTypes.map(stepType => (
					<MenuItem
						key={stepType.type}
						value={stepType.type}
						sx={{
							height: "48px",
							display: "flex",
							alignItems: "center"
						}}
					>
						{stepType.icon}
						<span style={{ marginLeft: 8 }}>{t(stepType.label)}</span>
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default SelectMenuStep;
